import { exhaustiveCheck } from 'common/utils';
import i18n from 'i18n';
import { EventWizardStep } from 'pages/EventWizard/constants';

import { EventWizardMode } from '../types';

import type { Step } from 'common/components/TaskStepper';
import type { EventWizardStepConfig } from 'pages/EventWizard/stepConfigs';

export const getEventWizardInitialSteps = (mode: EventWizardMode, stepConfigs: EventWizardStepConfig[]): Step[] => {
  const steps = stepConfigs.map((config) => {
    const { title, description } = i18n.t(`event:wizard.steps.${config.i18nKey}` as any, {
      returnObjects: true,
    }) as { title: string; description: string };

    return { title, description };
  });

  switch (mode) {
    case 'create':
      return steps.map((step, i) => ({
        ...step,
        status: i === 0 ? 'IN_PROGRESS' : 'NOT_STARTED',
      }));
    case 'edit':
      return steps.map((step) => ({
        ...step,
        status: 'COMPLETED',
      }));
    case 'repeat':
    case 'template': {
      const eventDetailsIndex = stepConfigs.findIndex((c) => c.step === EventWizardStep.EventDetails);
      return steps.map((step, i) => ({
        ...step,
        status: i === eventDetailsIndex ? 'IN_PROGRESS' : 'COMPLETED',
      }));
    }
    default:
      exhaustiveCheck(mode);
  }
};
